import { render, staticRenderFns } from "./billDetails.vue?vue&type=template&id=9f978222&scoped=true"
import script from "./billDetails.vue?vue&type=script&lang=ts"
export * from "./billDetails.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f978222",
  null
  
)

export default component.exports